import React from 'react'
import ImageComponent from '../../ImageComponent'
import { currencyFormat, i18nTranslate } from 'src/utils'
import './styles.scss'

const ItemDetails = ({ key, itemDetails = {}, customClass = '' }) => {
  return (
    <div key={key} className={`d-flex ${customClass}`}>
      <div className="p-2">
        <ImageComponent
          width="86px"
          height="86px"
          optimizeImage={true}
          src={itemDetails?.image}
          alt={itemDetails?.name}
          className="free-gift-image"
          data-testid="qa-free-gift-image"
        />
      </div>
      <div className="p-2 flex-grow-1">
        <span className="free-gift-name">{itemDetails?.name}</span>
        {itemDetails?.skuId && (
          <span className="free-gift-qty">
            {i18nTranslate('cart.itemId', 'SKU')}: {itemDetails.skuId}
          </span>
        )}
        <span className="free-gift-qty">
          {i18nTranslate('subscriptionsAllHeader.QTY', 'QTY')}:{' '}
          {itemDetails?.qty}
        </span>
        {itemDetails?.price && (
          <span className="free-gift-price">
            {currencyFormat({
              price: itemDetails.price,
            })}
          </span>
        )}
      </div>
    </div>
  )
}

export default ItemDetails
